import { VerifyCollectionButton } from '../VerifyCollectionButton';
import { PortalCard } from '../portal';

interface AppCollectionVerificationPromptProps {
  appData: {
    id: string;
    canManageNfts?: boolean;
    nftMintAddress: string | null;
    publisherNftMintAddress?: string | null;
    publisherWalletAddress?: string | null;
  } | null;
  isAppCollectionVerified: boolean | null;
  onVerificationSuccess: () => void;
}

export function AppCollectionVerificationPrompt({
  appData,
  isAppCollectionVerified,
  onVerificationSuccess,
}: AppCollectionVerificationPromptProps) {
  if (
    appData?.canManageNfts !== true ||
    !appData.nftMintAddress ||
    !appData.publisherNftMintAddress ||
    !appData.publisherWalletAddress ||
    isAppCollectionVerified !== false
  ) {
    return null;
  }

  return (
    <PortalCard className="motion-enter flex flex-col gap-4 border-orange-900/40 p-6 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2 text-sm font-bold text-white">
          <span
            aria-hidden="true"
            className="size-2 rounded-full bg-orange-400 animate-live-pulse"
          />
          App collection verification required
        </div>
        <p className="text-sm text-seeker-400">
          This App NFT needs to be verified as part of the publisher collection.
        </p>
      </div>
      <VerifyCollectionButton
        dappId={appData.id}
        nftMintAddress={appData.nftMintAddress}
        collectionMintAddress={appData.publisherNftMintAddress}
        collectionAuthority={appData.publisherWalletAddress}
        verificationTarget="app"
        onSuccess={onVerificationSuccess}
        className="w-full sm:w-auto"
        variant="outlineWhite"
      />
    </PortalCard>
  );
}
